/**Dependencies */
import React, { useState } from "react";
import useForm from "../hooks/useForm";

/**Components */
import { PrincipalBanner } from "../components/PrincipalBanner";
import { Container, Row, Col, Form, Button, Modal } from "react-bootstrap";
import { CardsProducts } from "../components/CardsProducts";
import { Swiper, SwiperSlide } from "swiper/react";
import Swal from "sweetalert2";

// Services
import { getEmailText } from "../services/emailService";

/**Images */
import bannerLunaMiel from "../images/banners/Banner sandals luna.png";
import imgForm from "../images/banners/sandals-from.png";

import sandalsSaint from "../images/Sandals Saint Vincent.png";
import sandalsCuracao from "../images/Sandals Royal Curacao.png";
import sandalsCaribbean from "../images/Sandals Royal Caribbean.png";
import sandalsRiver from "../images/Sandals Dunn´s River.png";

export const Sandals = () => {
  const [showModal, setShowModal] = useState(false);
  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const resortsArr = [
    {
      urlImg: sandalsSaint,
      hotel: "Sandals Saint Vincent",
      location: "Saint Vincent",
      desc: "El resort todo incluido de Sandals, el más nuevo de San Vicente, donde podrá salirse de los caminos trillados y explorar la maravilla poco conocida del Caribe.",
    },
    {
      urlImg: sandalsCuracao,
      hotel: "Sandals Royal Curacao",
      location: "Curacao",
      desc: "El resort todo incluido más nuevo de Sandals en Curazao es donde el romance natural de esta íntima isla cobra vida. Lo verás en la linea donde el paisaje desértico desciende suavemente hacia el océano azul.",
    },
    {
      urlImg: sandalsCaribbean,
      hotel: "Sandals Royal Caribbean",
      location: "Jamaica",
      desc: "Este lujoso resort todo incluido en Jamaica abraza la refinada herencia británica con una gran casa de estilo georgiano. Crea vacaciones en donde también encontrará una muestra isleña de cálida hospitalidad, sonidos de tambores de acero y los ritmos de una elegante vida nocturna caribeña.",
    },
    {
      urlImg: sandalsRiver,
      hotel: "Sandals Dunn’s River",
      location: "Jamaica",
      desc: "En la costa norte de Jamaica, los ríos serpentean a través de bosques y cascadas bañan el paisaje. En este lugar apartado, lleno de la abundancia de la tierra, el amor fluye naturalmente.",
    },
  ];
  let initialState = {
    emailAddress: "info@tranet.com.mx",
    destinatarioCC: "hola@marketingdirigido.com",
    asunto: "Han Solicitado información",
    fullName: "",
    email: "",
    phone: "",
    resort: "",
  };

  const validations = {
    fullName: {
      test: (value) => /^[a-zA-Z\s]*$/.test(value),
      message: "El nombre solo puede contener letras y espacios.",
    },
    phone: {
      test: (value) => /^\d*$/.test(value),
      message: "El teléfono solo puede contener números.",
    },
    resort: {
      test: (value) => /^[a-zA-Z\s]*$/.test(value),
      message: "El nombre solo puede contener letras y espacios.",
    },
  };

  const { formData, handleChange, handleSubmit, resetForm } = useForm(
    initialState,
    validations
  );

  /**
   * Función para manejar el envío del formulario de Sandals,
   * esta función se encarga de tomar los datos del formulario,
   * llamar al servicio para enviar el correo y mostrar un mensaje
   * de success o error dependiendo del resultado.
   *
   * @returns {Promise<void>}
   */
  const submitForm = async () => {
    const dataArray = {
      destinatario: formData.emailAddress,
      destinatarioCC: formData.destinatarioCC,
      asunto: formData.asunto,
      mensaje: `Nombre Completo: ${formData.fullName} \nEmail: ${formData.email} \nNúmero de Teléfono: ${formData.phone} \nResort: ${formData.resort}`, // Usa la interpolación correctamente
    };

    try {
      await getEmailText(dataArray);
      resetForm();
      Swal.fire({
        title: "Correo enviado exitosamente!",
        text: "El correo ha sido enviado, nos contactaremos con usted lo antes posible.",
        icon: "success",
      });
    } catch (error) {
      console.error("Error al enviar el formulario:", error);
      Swal.fire({
        icon: "error",
        title: "Hubo un error al enviar el correo.",
        text: "Por favor intentelo mas tarde.",
      });
    }
  };

  return (
    <div className="sandals">
      <PrincipalBanner idElemento={5} />
      <Container className="py-5">
        <div className="text-center">
          <h1 className="section-title outline mb-5">Grupo Sandals</h1>
          <p className="section-subtitle text-c" style={{ textAlign: "start" }}>
            Somos International Travel Net, una agencia de viajes certificada
            por Grupo Sandals trabajando para brindarte los mejores resorts y
            vivas unas vacaciones espectaculares.
          </p>
        </div>
      </Container>
      <Container className="py-5">
        <div className="text-center mb-5">
          <h1 className="section-title">Resorts</h1>
        </div>

        <Row>
          <Swiper
            spaceBetween={0}
            slidesPerView={1}
            loop={true}
            autoplay={{ delay: 3000 }}
            breakpoints={{
              640: {
                slidesPerView: 1,
              },
              768: {
                slidesPerView: 2,
              },
              1024: {
                slidesPerView: 4,
              },
            }}
          >
            {resortsArr.map((item, index) => (
              <SwiperSlide key={index}>
                <Col md={12} lg={12} key={index} className="mb-4">
                  <CardsProducts
                    infoCards={item}
                    type={"sandals"}
                    handleShowModal={handleShowModal}
                  />
                </Col>
              </SwiperSlide>
            ))}
          </Swiper>
        </Row>

        <Modal show={showModal} onHide={handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title>Más información</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Aquí puedes agregar más detalles sobre Sandals Royal Curacao o
            cualquier contenido que desees mostrar.
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              Cerrar
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>

      <div className="py-5" style={{ width: "100%" }}>
        <img
          src={bannerLunaMiel}
          alt="Banner auroras boreales"
          style={{ width: "100%" }}
        />
      </div>

      <div
        className="py-5 container"
        style={{ position: "relative", height: "600px" }}
      >
        <img
          src={imgForm}
          alt="Imagen"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            borderRadius: "25px",
          }}
        />
        <div
          style={{
            position: "absolute",
            top: "50%",
            right: "5%",
            transform: "translateY(-50%)",
            backgroundColor: "transparent",
            padding: "30px",
            borderRadius: "10px",
            width: "80%",
            maxWidth: "600px",
            textAlign: "start",
            color: "white",
          }}
        >
          <h2 style={{ fontSize: "30px" }}>Conoce los resorts.</h2>
          <br />
          <Form onSubmit={(e) => handleSubmit(e, submitForm)}>
            <Row className="g-4">
              <Col xs={12} md={12}>
                <Form.Group controlId="formNombre">
                  <Form.Label>Nombre Completo</Form.Label>
                  <Form.Control
                    type="text"
                    name="fullName"
                    value={formData.fullName}
                    onChange={handleChange}
                    className="input-light text-white"
                    required
                  />
                </Form.Group>

                <Form.Group controlId="formCorreo">
                  <Form.Label>Correo Electrónico</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="input-light text-white"
                    required
                  />
                </Form.Group>

                <Form.Group controlId="formTelefono">
                  <Form.Label>Teléfono</Form.Label>
                  <Form.Control
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    maxLength={10}
                    className="input-light text-white"
                    required
                  />
                </Form.Group>

                <Form.Group controlId="formResort">
                  <Form.Label>Resort de tu interes</Form.Label>
                  <Form.Control
                    type="text"
                    name="resort"
                    onChange={handleChange}
                    value={formData.resort}
                    className="input-light text-white"
                    maxLength={50}
                    required
                  />
                </Form.Group>
                <div className="d-flex justify-content-center">
                  <Button
                    className="btn-white"
                    type="submit"
                    style={{
                      width: "20%",
                      height: "35px",
                      marginTop: "25px",
                      fontSize: "16px",
                    }}
                  >
                    Cotiza
                  </Button>
                </div>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    </div>
  );
};
